const storageKey = "SCVKO_TARGET_PATH_AFTER_LOGIN";

export function isLoginUrl(url) {
  return url && url.includes("/login");
}

export function isSilent401Url(url) {
  return url && url.includes("/user-activity");
}

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const payload = JSON.parse(json);
    return typeof payload.exp !== "number" || Date.now() >= payload.exp * 1000;
  } catch {
    return false;
  }
}

export function clearAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("modules");
  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
}

export function saveTargetPath(path) {
  path = path || window.location.hash.substr(1);
  if (isLoginUrl(path)) {
    return false;
  }
  sessionStorage.setItem(storageKey, path);
  return true;
}

export function getTargetPath(qwe) {
  let path = sessionStorage.getItem(storageKey);
  if (isLoginUrl(path)) {
    path = "/";
    saveTargetPath(path);
  }
  return path;
}
